import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=fa22a0d6"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa22a0d6')) {
      api.createRecord('fa22a0d6', component.options)
    } else {
      api.reload('fa22a0d6', component.options)
    }
    module.hot.accept("./Onboarding.vue?vue&type=template&id=fa22a0d6", function () {
      api.rerender('fa22a0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Onboarding.vue"
export default component.exports